var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.132812 8.94922C0.132812 9.1901 0.178385 9.41471 0.269531 9.62305C0.360677 9.82487 0.507161 10.0234 0.708984 10.2188L8.0918 17.4453C8.39128 17.7448 8.7526 17.8945 9.17578 17.8945C9.46224 17.8945 9.72266 17.8229 9.95703 17.6797C10.1979 17.543 10.39 17.3574 10.5332 17.123C10.6764 16.8887 10.748 16.6283 10.748 16.3418C10.748 15.9121 10.5788 15.528 10.2402 15.1895L3.80469 8.93945L10.2402 2.69922C10.5788 2.3737 10.748 1.99284 10.748 1.55664C10.748 1.27018 10.6764 1.00977 10.5332 0.775391C10.39 0.541016 10.1979 0.355469 9.95703 0.21875C9.72266 0.0755208 9.46224 0.00390625 9.17578 0.00390625C8.7526 0.00390625 8.39128 0.150391 8.0918 0.443359L0.708984 7.66992C0.513672 7.86523 0.370443 8.06706 0.279297 8.27539C0.188151 8.47721 0.139323 8.70182 0.132812 8.94922Z",
    fill: "#1B51A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.4c5e87ac5b1da37b9c7fb2736c582721.svg";
export { ForwardRef as ReactComponent };